import { useState } from "react"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import { SMOOTH_LINE_API_URL } from "src/lib/constants"
import {
  UpdateAutoAcquisitionAccountPasswordRequest,
  UpdateAutoAcquisitionAccountPasswordApiResponse,
  UseUpdateAutoAcquisitionAccountPasswordReturn,
} from "../types"

/**
 * AutoAcquisitionAccountを更新するカスタムフック
 */
export const useUpdateAutoAcquisitionAccountPassword =
  (): UseUpdateAutoAcquisitionAccountPasswordReturn => {
    const { patchWithToken } = useSmoothApi()
    const [isUpdating, setIsUpdating] = useState(false)
    const [error, setError] = useState<Error | null>(null)

    /**
     * アカウント情報を更新する関数
     * @param id - アカウントID
     * @param password - 新しいパスワード（オプション）
     * @param name - 新しい名前（オプション）
     */
    const updateAccount = async (id: number, password?: string, name?: string): Promise<void> => {
      setIsUpdating(true)
      setError(null)

      try {
        const url = `${SMOOTH_LINE_API_URL}/base_api/smoother/screen/auto_acquisition_accounts/${id}`
        const requestData: UpdateAutoAcquisitionAccountPasswordRequest = {}

        if (password !== undefined) {
          requestData.password = password
        }
        if (name !== undefined) {
          requestData.name = name
        }

        await patchWithToken<UpdateAutoAcquisitionAccountPasswordApiResponse>(url, requestData)
      } catch (err) {
        const errorMessage =
          err instanceof Error ? err.message : "アカウント情報の更新に失敗しました"
        setError(new Error(errorMessage))
        throw err
      } finally {
        setIsUpdating(false)
      }
    }

    return {
      updateAccount,
      isUpdating,
      error,
    }
  }
